<div class="nav-feature-card-grid-container" coreLinkClass>
  <div class="nav-feature-card-grid">
    @for (card of block.content; track card) {
      <a class="nav-feature-card" [href]="card.data.link.url">
        <div class="nav-feature-card__img-container">
          <img class="nav-feature-card__img" [src]="getImageUrl(card.data.image_url)" alt="" />
        </div>
        <div class="nav-feature-card__body">
          <h3 class="nav-feature-card__heading" [innerText]="card.data.heading"></h3>
          <div class="nav-feature-card__description" [innerHTML]="card.data.description | translate"></div>
          <span class="nav-feature-card__link">
            <span [innerText]="card.data.link.text | translate"></span>
            <!-- Right Arrow SVG -->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M4 11.5306C4 10.9896 4.43858 10.551 4.97959 10.551L16.4565 10.551L12.1631 6.70963C11.76 6.34889 11.7256 5.7296 12.0863 5.32641C12.447 4.92323 13.0663 4.88882 13.4695 5.24957L19.6736 10.8006C19.8813 10.9864 20 11.2519 20 11.5306C20 11.8093 19.8813 12.0748 19.6736 12.2607L13.4695 17.8117C13.0663 18.1724 12.447 18.138 12.0863 17.7348C11.7256 17.3316 11.76 16.7124 12.1631 16.3516L16.4565 12.5102L4.97959 12.5102C4.43858 12.5102 4 12.0716 4 11.5306Z"
                fill="currentColor" />
            </svg>
          </span>
        </div>
      </a>
    }
  </div>
</div>
